import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {labels} from '../../../../util/utils';
import {getCurrentMateriality} from '../../../../selectors/Ares/materiality';
import styled from 'styled-components';
import {getInUserNumberFormat, getInUserDateFormat, getMeasurementBasisLabel} from './MeasurementBasisConfig';
import Label from '../../BaseComponentWrappers/MotifLabel';
import {helixBasisAmount} from '../../../../util/uiconstants';
import MaterialityFetch from '../../Materiality/MaterialityFetch';
import _ from 'lodash';
import {useUserPreferences} from '../../../../util/customHooks';

const MeasurementBasisValue = (props) => {
	const {documentId} = props;
	const userPreferences = useUserPreferences();
	const currentMateriality = useSelector((store) => getCurrentMateriality(store));
	const [isRadioChecked, setIsRadioChecked] = useState(null);
	const [isCurrentAnalysisDateAmountValuePresent, setIsCurrentAnalysisDateAmountValuePresent] = useState(false);

	useEffect(() => {
		if (!_.isEmpty(currentMateriality)) {
			if (currentMateriality?.helixModel?.basisAmount) {
				setIsCurrentAnalysisDateAmountValuePresent(true);
			} else {
				setIsCurrentAnalysisDateAmountValuePresent(false);
			}

			setIsRadioChecked(currentMateriality?.helixModel?.isAnnualizedAmountExpectedToBeReported);
		}
	}, [currentMateriality]);

	return (
		<MaterialityFetch documentId={documentId}>
			<StyledMeasurementBasisValue className="customScrollbar">
				<section className="measurementbasisvalue-container">
					<section className="measurementbasis-type">
						<Label>{labels.measurementBasis}:</Label>
						<span className="measurementbasis-value">
							{getMeasurementBasisLabel(
								currentMateriality?.materialityTypeID,
								currentMateriality?.otherBasisDescription,
								currentMateriality?.helixModel?.basis
							)}
						</span>
					</section>
					{currentMateriality?.helixModel?.basisAmount !== helixBasisAmount.DEFAULT && (
						<section className={isCurrentAnalysisDateAmountValuePresent ? 'basisvalue-fromhelix' : 'hide'}>
							<Label>{labels.basisValueFromHelix}:</Label>
							<span className="basisvalue-value">
								{getInUserNumberFormat(currentMateriality?.helixModel?.basisAmount, userPreferences)}
							</span>
						</section>
					)}
					<section className={isCurrentAnalysisDateAmountValuePresent ? 'asof-date' : 'hide'}>
						<Label>{labels.asOfDate}:</Label>
						<span className="asofdate-value">
							{getInUserDateFormat(currentMateriality?.helixModel?.analysisDate, userPreferences)}
						</span>
					</section>
					<section className="annualized-basis">
						<Label>{labels.basisValue}:</Label>
						<span className="annualizedbasis-value">
							{currentMateriality?.basisAdjustedAmount !== null &&
							currentMateriality?.basisAdjustedAmount > helixBasisAmount.DEFAULT
								? getInUserNumberFormat(currentMateriality?.basisAdjustedAmount, userPreferences, false)
								: currentMateriality?.basisForecastAmount !== null &&
								  currentMateriality?.basisForecastAmount > helixBasisAmount.DEFAULT
								? getInUserNumberFormat(currentMateriality?.basisForecastAmount, userPreferences, false)
								: '-'}
						</span>
					</section>
					<section
						className={
							isRadioChecked === true || (isRadioChecked == null && isCurrentAnalysisDateAmountValuePresent)
								? 'hide'
								: 'annualizedvalue-question'
						}
					>
						<span className="annualized-question">{labels.rationaleDeterminationLabel}:</span>
						{currentMateriality?.basisForecastAmountRationale === '' ||
						currentMateriality?.basisForecastAmountRationale === null ? (
							<section className="NoResponseLabel">{labels.noResponseAvailable}</section>
						) : (
							<span className="rationale-forecast">{currentMateriality?.basisForecastAmountRationale}</span>
						)}
					</section>
				</section>
			</StyledMeasurementBasisValue>
		</MaterialityFetch>
	);
};

export default MeasurementBasisValue;

const StyledMeasurementBasisValue = styled.section`
	padding: var(--px-30) var(--px-155);
	height: 100%;
	.measurementbasisvalue-container {
		width: 100%;
		margin: var(--px-20) 0;
		padding: var(--px-20) var(--px-15) var(--px-15) var(--px-15);
		border-radius: var(--px-8);
		border: var(--px-1) solid var(--neutrals-300);
		font-size: var(--px-12);
		background: var(--neutrals-00white);
		.motif-icon.comment-icon {
			display:block;
			float:right;
			margin-top: calc(var(--px-5) * -1);
		}
		.motif-label {
			display:inline-block;
			width: auto;
		}
		.measurementbasis-type {
			.measurementbasis-value {
				display:inline-block;
				font-size: var(--px-14);
				font-weight: 300;
			}
		}
		.basisvalue-fromhelix {
			.basisvalue-value {
				display:inline-block;
				font-size: var(--px-14);
				font-weight: 300;
			}
		}
		.asof-date {
			.asofdate-value {
				display:inline-block;
				font-size: var(--px-14);
				font-weight: 300;
			}
		}
		.annualized-basis {
			.annualizedbasis-value {
				display:inline-block;
				font-size: var(--px-14);
				font-weight: 300;
			}
		}
		.annualizedvalue-question {
			//margin-top: var(--px-10);
			.annualized-question {
				display:block;
				font-size: var(--px-14);
				font-weight: 600;
				.txt-normal {
					font-weight: normal;
				}
			}
			.NoResponseLabel {
				font-size: var(--px-14);
			}
			.rationale-container
				.yes-container {
					display:block;
					font-size: var(--px-14);
					font-weight: 300;
					color:var(--neutrals-700);
					padding-left: var(--px-40);
				}
				.no-container {
					padding-left: var(--px-20);
					.motif-icon {
						color:var(--green-500);
						svg {
							width:var(--px-16) !important;
							height:var(--px-16) !important;
							vertical-align: text-bottom;
							cursor:default;
						}
					}
					.no-text {
						font-size: var(--px-12);
						font-weight: bold;
						color:var(--neutrals-900);
					}
				}
				.rationale-forecast {
					display:block;
					font-size: var(--px-14);
					font-weight: 300;
					white-space: pre-line;
					line-height: normal;
				}
				.rationale-incomplete {
					display:block;
					font-size: var(--px-12);
					font-weight: 300;
					padding-left: var(--px-50);
					color:var(--neutrals-700);
					.motif-icon {
						color:var(--neutrals-700);
						margin-right:var(--px-3);
						svg {
							width:var(--px-16) !important;
							height:var(--px-16) !important;
							vertical-align: text-bottom;
							cursor:default;
						}
					}
				}
			}
			.financialperiod-container {
				.no-container {
					display:block;
					font-size: var(--px-12);
					font-weight: 300;
					color:var(--neutrals-700);
					padding-left: var(--px-40);
				}
				.yes-container {
					padding-left: var(--px-20);
					.motif-icon {
						color:var(--green-500);
						svg {
							width:var(--px-16) !important;
							height:var(--px-16) !important;
							vertical-align: text-bottom;
							cursor:default;
						}
					}
					.yes-text {
						font-size: var(--px-12);
						font-weight: bold;
						color:var(--neutrals-900);
					}
				}
			}
		}
	}
`;
